import { combineReducers, configureStore } from '@reduxjs/toolkit';

import specialHeaderReducer from './slices/specialHeaderSlice'

const rootReducer = combineReducers({
    specialHeader: specialHeaderReducer,
});

export const setupStore = (preloadedState) => {
    return configureStore({
        reducer: rootReducer,
        preloadedState,
    });
};

// exported for testing
export default rootReducer;